import { useTranslation } from "react-i18next"
import { SubmitButton } from "../../../-components/Buttons"
import { Form } from "../../../-components/typed-form"

interface Props {
  userAuthenticationFactorId: number
}

export function ResendCodeForm({ userAuthenticationFactorId }: Props) {
  const { i18n, t } = useTranslation("app_server")
  return (
    <Form
      url="/api/UserAuthenticationFactor/SendCode"
      initialValues={{ userAuthenticationFactorId, language: i18n.language }}
      transform={(id) => id}
    >
      {() => (
        <SubmitButton>{t("UserAuthenticationFactor_ResendCode")}</SubmitButton>
      )}
    </Form>
  )
}
